import classNames from "classnames";
import first from "lodash/first";
import math from "lodash/math";
import times from "lodash/times";
import values from "lodash/values";
import PropTypes from "prop-types";
import React, { Component } from "react";

import iconSprite from "../../../../../images/img/chat/icons.svg";
import CustomerHappinessType from "../../../constants/ChatCustomerHappinessTypes";
import HappinessType from "../../../constants/ChatHappinessTypes";
import SvgIcon from "../../common/SvgIcon";

const STAR_COUNT = 5;

class RatingSystemFiveStars extends Component {
    constructor(props) {
        super();

        this.state = {
            hoveredRatingValue: -1,
            ratingBarIsHoveredOrTouched: false,
            selectedRatingValue: this.getInitialStarIndex(props) || -1,
        };

        this.getStarIndex = this.getStarIndex.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.onMove = this.onMove.bind(this);
        this.onRate = this.onRate.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }

    onMouseLeave() {
        this.setState({
            hoveredRatingValue: -1,
            ratingBarIsHoveredOrTouched: false,
        });
    }

    onMove(event) {
        const { selectedRatingValue } = this.state;

        this.setState({
            hoveredRatingValue: this.getStarIndex(event) || selectedRatingValue,
            ratingBarIsHoveredOrTouched: true,
        });
    }

    onRate(event, key) {
        const starIndex = key || this.getStarIndex(event);

        if (starIndex > 0 && starIndex <= STAR_COUNT) {
            this.setState({ selectedRatingValue: starIndex });
            this.props.onRate(`STARS_${starIndex}`);
        }
    }

    handleKeyPress(event, key) {
        if (event.keyCode === 32 || event.keyCode === 13) {
            this.onRate(event, key);
        }
    }

    getInitialStarIndex({ customerHappiness, happiness }) {
        const customerHappinessStarIndexMap = {
            [CustomerHappinessType.STARS_1]: 1,
            [CustomerHappinessType.STARS_2]: 2,
            [CustomerHappinessType.STARS_3]: 3,
            [CustomerHappinessType.STARS_4]: 4,
            [CustomerHappinessType.STARS_5]: 5,
        };
        const happinessStarIndexMap = {
            [HappinessType.negative]: 1,
            [HappinessType.neutral]: 3,
            [HappinessType.positive]: 5,
        };

        return customerHappinessStarIndexMap[customerHappiness] || happinessStarIndexMap[happiness];
    }

    getStarIndex(event) {
        const touchEvent = first(event.changedTouches);
        const eventPageX = touchEvent ? touchEvent.pageX : event.pageX;
        const starButton = this.refs.starButton_1;
        const eventOffsetX = (eventPageX - starButton.offsetLeft) / starButton.offsetWidth;

        /*
         * On touch events we want to highlight the currently touched star even
         * if we are slightly touching it; as opposed, on mouse events we want
         * to make sure the mouse is actually over a star until we highlight it.
         */
        return touchEvent ? math.ceil(eventOffsetX) : math.round(eventOffsetX);
    }

    render() {
        const { hoveredRatingValue, ratingBarIsHoveredOrTouched, selectedRatingValue } = this.state;
        const starButtons = times(STAR_COUNT, index => {
            const key = index + 1;
            const isHoveredOrTouched = key <= hoveredRatingValue;
            const isSelected = ratingBarIsHoveredOrTouched ? false : key <= selectedRatingValue;
            const buttonClasses = classNames({
                "rate-btn": true,
                "star-btn": true,
                "rate-btn-first": key === 1,
                "rate-btn-last": key === STAR_COUNT,
            });
            const name = `rate ${key} star${key === 1 ? "" : "s"}`;

            return (
                <button
                    className={buttonClasses}
                    key={key}
                    name={name}
                    aria-label={name}
                    onClick={this.onRate}
                    onMouseLeave={this.onMouseLeave}
                    onMouseMove={this.onMove}
                    onTouchEnd={this.onRate}
                    onTouchMove={this.onMove}
                    onKeyDown={event => this.handleKeyPress(event, key)}
                    ref={`starButton_${key}`}
                >
                    <SvgIcon
                        id={isSelected || isHoveredOrTouched ? "icon-star" : "icon-star-border"}
                        src={iconSprite}
                    />
                </button>
            );
        });

        return <div className="rating-system-container">{starButtons}</div>;
    }
}

RatingSystemFiveStars.propTypes = {
    customerHappiness: PropTypes.oneOf(values(CustomerHappinessType)),
    onRate: PropTypes.func.isRequired,
    happiness: PropTypes.oneOf(values(HappinessType)),
};

export default RatingSystemFiveStars;
